import {createSelector} from "@reduxjs/toolkit";

import type ChapterSettingsOverride from "./ChapterSettingsOverride";
import type FetchStatus from "../FetchStatus";
import type {RootState} from "../store";
import {requiresExplicitSessionStart} from "../chapters/Chapter";
import selectChapter from "../chapters/selectChapter";
import CourseType from "../courses/CourseType";

const empty: Readonly<ChapterSettingsOverride> = {};

function selectTestSettingsOverride(
	state: Readonly<RootState>,
	key: string
): Readonly<ChapterSettingsOverride> | null {
	return state.chapterSettingsOverrides.byKey[key]?.override ?? null;
}

function selectTestSettingsOverrideFetchStatus(
	state: Readonly<RootState>,
	key: string
): FetchStatus {
	return state.chapterSettingsOverrides.byKey[key]?.status ?? "none";
}

const selectChapterSettingsOverride = createSelector(
	selectChapter,
	selectTestSettingsOverride,
	(chapter, override) => {
		if (!chapter) {
			return null;
		}

		if (!requiresExplicitSessionStart(CourseType.Ordinary, chapter)) {
			return empty;
		}

		return override;
	}
);

const selectChapterSettingsOverrideFetchStatus = createSelector(
	selectChapter,
	selectTestSettingsOverrideFetchStatus,
	(chapter, status) => {
		if (!chapter) {
			return "none";
		}

		if (!requiresExplicitSessionStart(CourseType.Ordinary, chapter)) {
			return "succeeded";
		}

		return status;
	}
);

export default selectChapterSettingsOverride;
export {selectChapterSettingsOverrideFetchStatus};
